// extracted by mini-css-extract-plugin
module.exports = {"confirmArea":"Confirm_confirmArea_2Sdeq","notice":"Confirm_notice_3s4a-","btnsWrap":"Confirm_btnsWrap_3e2S4"};